export const TIME_SLOTS = {
  WORK_START: '0800',
  WORK_END: '1659',
  EVENING_START: '1700'
} as const;

export const DEFAULT_HOURS = 1;

export const FALLBACK_CRITERIA: { [key: string]: { 
  Class: string[];
  languagePreference: string[];
  order_state: string[];
  Gender?: string[];
  minAge?: number;
  phoneModel?: string[];
}} = {
  web: {
    Class: ['Face', 'Hair'],
    languagePreference: ['en'],
    order_state: ['NEW_USER'],
  },
  ios: {
    Class: ['Face', 'Hair'],
    languagePreference: ['en'],
    order_state: ['NEW_USER'],
  },
  android: {
    Class: ['Face', 'Hair'],
    Gender: ['Female'],
    languagePreference: ['en'],
    minAge: 24,
    order_state: ['NEW_USER'],
    phoneModel: ['abc', 'test-phone'],
  },
}; 